import { Injectable } from '@angular/core';
import {Cache} from './util-storage.provider'; // Decorator to access local storage
import { environment } from "@env/environment";

let OneSignal;

const url = '';

@Injectable()
export class OneSignalService {
    @Cache({pool: 'OneSignal'}) oneSignalInit; // to check if OneSignal is already initialized. 
    @Cache({pool: 'OneSignal'}) oneSignalId: any; // store OneSignalId in localStorage
    @Cache({pool: 'Token'}) userSession: any; // User Session management token
    private oneSignalAppId: string;

    constructor() {
    }

    initOneSignal() {
      this.oneSignalAppId = environment.ONESIGNAL_APP_ID;
        OneSignal = window['OneSignal'] || [];
        OneSignal.push(['init', {
            appId: this.oneSignalAppId,
            autoRegister: true,
            allowLocalhostAsSecureOrigin: true,
            notifyButton: {
                enable: false,
            }
        }]);
        this.checkIfSubscribed();
    }

    sendPushTags(userId, userRole) {
        // OneSignal.push(["sendTag", "role", "role_name"]);
        OneSignal.push(["sendTag", "role", userRole]);
        // Here userId passed is ecosystm userId
        OneSignal.push(function() {
            OneSignal.setExternalUserId(userId);
          });
        this.checkIfSubscribed();
    }

    subscribe() {
        OneSignal.push(() => {
            OneSignal.push(['registerForPushNotifications']);
            OneSignal.on('subscriptionChange', (isSubscribed) => {
                this.listenForNotification();
                OneSignal.getUserId().then((userId) => {
                    // oneSignalId is the deviceToken
                    this.oneSignalId = userId;
                });
            });
        });
    }

    listenForNotification() {
        OneSignal.on('notificationDisplay', (event) => {
            this.listenForNotification();
        });
    }

    getUserID() {
        OneSignal.getUserId().then((userId) => {
            this.oneSignalId = userId;
        });
    }

    checkIfSubscribed() {
        OneSignal.push(() => {
            /* These examples are all valid */
            OneSignal.isPushNotificationsEnabled((isEnabled) => {
                if (isEnabled) {
                    this.getUserID();
                } else {
                    this.subscribe();
                }
            }, (error) => {
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/onesignal.service.ts